'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(TrackEvent2) {
  TrackEvent2["USER_ACTIVITY"] = "Wand.userActivity";
  TrackEvent2["SEARCH"] = "Wand.search";
  TrackEvent2["BALANCE"] = "Wand.balance";
  TrackEvent2["GAME"] = "Wand.game";
  TrackEvent2["GAME_CATEGORY"] = "Wand.gameCategory";
  TrackEvent2["REGISTRATION"] = "Wand.registration";
  TrackEvent2["DEPOSIT"] = "Wand.deposit";
  TrackEvent2["WITHDRAWAL"] = "Wand.withdrawal";
  TrackEvent2["KYC"] = "Wand.KYC";
  TrackEvent2["RG_QUESTIONNAIRE"] = "Wand.rgquestionnaire";
  TrackEvent2["SEASONAL_EVENT"] = "Wand.seasonalEvent";
  TrackEvent2["MEMBERSHIP_REGISTRATION"] = "Wand.membershipRegistration";
})(exports.TrackEvent || (exports.TrackEvent = {}));
(function(TrackEventCategory2) {
  TrackEventCategory2["LOGIN"] = "Login";
  TrackEventCategory2["PAGE_VIEW"] = "pageView";
  TrackEventCategory2["SELF_EXCLUSION"] = "selfExclusion";
  TrackEventCategory2["COOKIE_CONSENT"] = "cookieConsent";
  TrackEventCategory2["BALANCE"] = "Balance";
  TrackEventCategory2["LOBBY"] = "Lobby";
  TrackEventCategory2["CASINO"] = "Casino";
  TrackEventCategory2["LIVE_CASINO"] = "Live Casino";
  TrackEventCategory2["REGISTRATION"] = "Registration";
  TrackEventCategory2["DEPOSIT"] = "Deposit";
  TrackEventCategory2["WITHDRAWAL"] = "Withdrawal";
  TrackEventCategory2["QUICK_DEPOSIT"] = "QuickDeposit";
  TrackEventCategory2["SEARCH"] = "Search";
  TrackEventCategory2["UPLOAD_DOCUMENT"] = "uploadKycDocument";
  TrackEventCategory2["RG_QUESTIONNAIRE"] = "RGQuestionnaire";
  TrackEventCategory2["SEASONAL_EVENT"] = "Seasonal Event";
  TrackEventCategory2["MEMBERSHIP_REGISTRATION"] = "membershipRegistration";
})(exports.TrackEventCategory || (exports.TrackEventCategory = {}));
(function(UserActivityAction2) {
  UserActivityAction2["LOGGED_IN"] = "loggedIn";
  UserActivityAction2["LOGIN_FAILED"] = "failed";
  UserActivityAction2["FIRST_LOGIN"] = "firstLogin";
  UserActivityAction2["LOGGED_OUT"] = "loggedOut";
  UserActivityAction2["COOKIES_ACCEPTED"] = "accepted";
})(exports.UserActivityAction || (exports.UserActivityAction = {}));
(function(UserBalanceEventAction2) {
  UserBalanceEventAction2["NEAR_ZERO"] = "Near Zero";
  UserBalanceEventAction2["ZERO"] = "Zero";
})(exports.UserBalanceEventAction || (exports.UserBalanceEventAction = {}));
(function(GameEventAction2) {
  GameEventAction2["REAL_PLAY"] = "Play";
  GameEventAction2["FREE_PLAY"] = "Play for free";
  GameEventAction2["END_PLAY"] = "Stop";
})(exports.GameEventAction || (exports.GameEventAction = {}));
(function(RegisterEventAction2) {
  RegisterEventAction2["CLOSE"] = "Close";
  RegisterEventAction2["EDIT_PHONE"] = "Phone edit";
  RegisterEventAction2["RESEND_CODE"] = "Resend code";
  RegisterEventAction2["RESEND_EMAIL"] = "Resend email";
  RegisterEventAction2["ATTEMPT"] = "Attempt";
  RegisterEventAction2["ACCEPTED"] = "Accepted";
  RegisterEventAction2["CONFIRMED"] = "NRC";
})(exports.RegisterEventAction || (exports.RegisterEventAction = {}));
(function(DepositEventAction2) {
  DepositEventAction2["OPEN"] = "Open";
  DepositEventAction2["STARTED"] = "Started";
  DepositEventAction2["ATTEMPT"] = "Attempt";
  DepositEventAction2["DEPOSIT"] = "DC";
  DepositEventAction2["ERROR"] = "Error";
  DepositEventAction2["FTD"] = "FTD";
  DepositEventAction2["NDC"] = "NDC";
})(exports.DepositEventAction || (exports.DepositEventAction = {}));
(function(WithdrawalEventAction2) {
  WithdrawalEventAction2["OPEN"] = "Open";
  WithdrawalEventAction2["STARTED"] = "Started";
  WithdrawalEventAction2["ATTEMPT"] = "Attempt";
  WithdrawalEventAction2["WITHDRAW"] = "Success";
  WithdrawalEventAction2["ERROR"] = "Error";
})(exports.WithdrawalEventAction || (exports.WithdrawalEventAction = {}));
(function(QuickDepositEventAction2) {
  QuickDepositEventAction2["INTENT"] = "Intent";
  QuickDepositEventAction2["ATTEMPT"] = "Attempt";
  QuickDepositEventAction2["SUCCESS"] = "Success";
  QuickDepositEventAction2["ERROR"] = "Error";
})(exports.QuickDepositEventAction || (exports.QuickDepositEventAction = {}));
(function(SeasonalEventAction2) {
  SeasonalEventAction2["GIFT_SELECTED"] = "Gift Selected";
  SeasonalEventAction2["CLOSE"] = "Close";
  SeasonalEventAction2["CTA"] = "View more details";
})(exports.SeasonalEventAction || (exports.SeasonalEventAction = {}));
(function(MembershipRegistrationEventAction2) {
  MembershipRegistrationEventAction2["ACCEPTED"] = "Accepted";
  MembershipRegistrationEventAction2["ATTEMPT"] = "Attempt";
  MembershipRegistrationEventAction2["CLOSE"] = "Close";
})(exports.MembershipRegistrationEventAction || (exports.MembershipRegistrationEventAction = {}));
